var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V20H0V0Z",
    fill: "#F9F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8616 16.4785C18.4939 16.4493 17.4058 15.3138 17.435 13.9462L17.5032 10.7469L15.9836 10.7145L15.9154 13.9138C15.8683 16.1212 17.6217 17.951 19.8292 17.9981C22.0367 18.0452 23.8665 16.2918 23.9135 14.0843L23.9818 10.885L22.4621 10.8526L22.3939 14.0519C22.3647 15.4196 21.2293 16.5076 19.8616 16.4785ZM20.7313 13.2163L20.8678 6.81772L19.2681 6.78361L19.1317 13.1822L20.7313 13.2163ZM16.0859 5.91557L16.0177 9.11484L17.5373 9.14725L17.6056 5.94797C17.6347 4.58028 18.7702 3.49224 20.1379 3.52141C21.5056 3.55057 22.5936 4.68602 22.5644 6.05371L22.4962 9.25299L24.0159 9.28539L24.0841 6.08612C24.1312 3.87862 22.3778 2.04882 20.1703 2.00175C17.9628 1.95468 16.133 3.70807 16.0859 5.91557Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLinked);
export default __webpack_public_path__ + "static/media/icon_user_linked.0f52d8a505898ada938dbace270fdbd6.svg";
export { ForwardRef as ReactComponent };